import Text from '@sats-group/ui-lib/react/text/text';
import cn from 'classnames';
import React from 'react';
import type { OpenStatus as Props } from './open-status.types';

// NOTE: This could be implemented as a hook, but then we wouldn't get any 'prop-types' validation which we want since the props are sort of complicated.
const OpenStatus: React.FunctionComponent<Props> = ({
  isOpen,
  isClosingSoon,
  metaText,
  shouldShowStatus = true,
  statusText,
}) => (
  <div className="open-status">
    {shouldShowStatus ? (
      <Text
        className={cn('open-status__status', {
          'open-status__status--closing-soon': isOpen && isClosingSoon,
          'open-status__status--open': isOpen && !isClosingSoon,
        })}
        key={statusText}
        size={Text.sizes.small}
        theme={Text.themes.emphasis}
      >
        {statusText}
      </Text>
    ) : null}
    <Text size={Text.sizes.small}>{metaText}</Text>
  </div>
);

export default OpenStatus;
